import { Controller } from "@hotwired/stimulus"

// Phase 2.8 Tier 3 — polls the snapshot history JSON endpoint when a
// run is in flight (status ∈ {pending, running}). Stops polling as
// soon as every visible row is in a terminal state.
//
// Activated when the surrounding view sets data-report-snapshot-history-url-value;
// otherwise the controller does nothing and the static page renders fine.
export default class extends Controller {
  static values = { url: String, intervalMs: { type: Number, default: 4000 } }

  connect() {
    this.timer = null
    this.scheduleNextPoll()
  }

  disconnect() {
    if (this.timer) clearInterval(this.timer)
  }

  scheduleNextPoll() {
    if (!this.hasUrlValue || this.urlValue.length === 0) return
    if (!this.hasInFlightRow()) return

    this.timer = setTimeout(() => this.poll(), this.intervalMsValue)
  }

  hasInFlightRow() {
    return Array.from(this.element.querySelectorAll("tbody tr")).some(row => {
      const status = (row.dataset.status || "").toLowerCase()
      return status === "pending" || status === "running"
    })
  }

  async poll() {
    try {
      const res = await fetch(this.urlValue, { headers: { "Accept": "application/json" } })
      if (!res.ok) return
      const runs = await res.json()
      this.renderRows(runs)
      if (this.hasInFlightRow()) this.scheduleNextPoll()
    } catch (err) {
      console.warn("[report-snapshot-history] poll failed", err)
    }
  }

  renderRows(runs) {
    const tbody = this.element.querySelector("tbody")
    if (!tbody || !Array.isArray(runs)) return

    tbody.innerHTML = runs.map(r => `
      <tr data-status="${r.status}">
        <td class="px-3 py-2">${r.completed_at || "—"}</td>
        <td class="px-3 py-2 capitalize">${r.status}</td>
        <td class="px-3 py-2 text-right">${r.row_count ?? "—"}</td>
        <td class="px-3 py-2 text-gray-600">${r.scheduled ? "Scheduled" : (r.triggered_by || "—")}</td>
        <td class="px-3 py-2 text-right"></td>
      </tr>
    `).join("")
  }
}
